var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hubble-plot-x-axis-scale-control"},[_c('v-range-slider',{attrs:{"dense":"","min":_vm.minValue,"max":_vm.maxValue,"value":_vm.displayValue,"step":60000,"thumb-label":false},on:{"input":function($event){return _vm.setRangeValue($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }